import { ArrowUpRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { WhatsAppIcon } from '@/components/WhatsAppIcon';
import { buildWhatsAppLink, WA_MESSAGES } from '@/lib/whatsapp';

export const WhatsAppCta = ({ testId, message = WA_MESSAGES.siteVisit, children, booking = false, className = '', tier }) => (
  <Button asChild className={`gg-whatsapp ${booking ? 'gg-whatsapp-booking' : ''} ${className}`}>
    <a href={buildWhatsAppLink(message)} target="_blank" rel="noopener noreferrer"
      data-testid={testId} data-cta-location={testId}
      data-pkg-name={tier?.name} data-pkg-price={tier?.price}>
      <WhatsAppIcon className="h-5 w-5 shrink-0" />
      {booking ? <span className="gg-booking-label"><strong>Booking Slot Site Visit Sekarang</strong><small>melalui WhatsApp</small></span> : <span>{children}</span>}
      <ArrowUpRight className="gg-cta-arrow h-4 w-4 shrink-0" />
    </a>
  </Button>
);